import type { FC } from 'react';

import barCodeBlur1x from '../../assets/barCodeBlur-1x.webp';
import barCodeBlur2x from '../../assets/barCodeBlur-2x.webp';
import pauseIcon from '../../icons/pause-icon.svg?url';

import {
	StyledBlurredAztecCodeImg,
	StyledBlurredAztecCodeWrapper,
	StyledOverlayContainer,
	StyledPauseIconWrapper,
} from './BlurredAztecCode.styled';

interface IBlurredAztecCodeProps {
	id?: string;
	paused?: boolean;
}

export const BlurredAztecCode: FC<IBlurredAztecCodeProps> = ({
	id = 'blurred-aztec-code',
	paused = false,
}) => (
	<StyledBlurredAztecCodeWrapper>
		<StyledBlurredAztecCodeImg
			id={id}
			src={barCodeBlur1x}
			srcSet={`${barCodeBlur1x} 1x, ${barCodeBlur2x} 2x`}
			alt="fallback Deutschland ticket code illustration"
		/>
		{paused && (
			<>
				<StyledOverlayContainer />
				<StyledPauseIconWrapper>
					<img
						src={pauseIcon}
						alt="Paused illustration icon"
						width="64"
						height="64"
					/>
				</StyledPauseIconWrapper>
			</>
		)}
	</StyledBlurredAztecCodeWrapper>
);
